import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { CreditListFilter, CreditListResponse } from '../models'

export class GetCreditListApi extends ClientProxy {
  constructor(props: any = {}) {
    super({
      url: 'compay-payment/serial-credit-list',
      ...props,
    })
  }

  public async getCreditList(filter: CreditListFilter): Promise<CreditListResponse> {
    return await this.postAsync<CreditListResponse>(filter)
  }
}
